// components/FilesSection.jsx
import React from "react";

const FilesSection = ({
  files,
  handleUploadClick,
  fileInputRef,
  handleFileSelect,
  handleDeleteFile,
  editMode,
}) => {
  return (
    <div
      className="calculador-archivos-container"
      style={{ 
        margin: "0", gap: "0",
        ...( !editMode ? { pointerEvents: "none", opacity: 0.9 } : {} ) 
      }}
    >
      <h1 className="calculador-title">Archivos</h1>
      <p className="archivos-subtitle">
        Sube tus imágenes o documentos, se enviarán como archivos adjuntos
      </p>
      <div className="upload-area" onClick={handleUploadClick}>
        <i className="bi bi-cloud-upload upload-icon"></i>
        <p className="upload-text">
          <span className="upload-click">Click para subir</span> ó arrastrar
        </p>
        <p className="upload-size">
          Puedes cargar un máximo de 10 archivos, cada uno de 3 MB
        </p>
      </div>
      <input
        type="file"
        multiple
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileSelect}
      />
      {files.length > 0 && (
        <div className="archivos-list">
          {files.map((file) =>
            file.status === "uploading" ? (
              <div className="archivo-item uploading" key={file.id}>
                <i className="bi bi-file-earmark-image archivo-icon"></i>
                <div className="archivo-info">
                  <p className="archivo-name">Cargando {file.nombre}</p>
                  <div className="progress-bar">
                    <div
                      className="progress-fill"
                      style={{ width: `${file.progress}%` }}
                    ></div>
                  </div>
                  <p className="progress-text">
                    {file.nombre} | {file.progress}% Completo
                  </p>
                </div>
                <i
                  className="bi bi-x-circle archivo-delete"
                  onClick={() => handleDeleteFile(file.id)}
                  style={{ cursor: "pointer" }}
                ></i>
              </div>
            ) : file.status === "success" ? (
              <div className="archivo-item success" key={file.id}>
                <i className="bi bi-check-circle archivo-success-icon"></i>
                <div className="archivo-info">
                  <p className="archivo-name">Cargado con Éxito</p>
                  <p className="archivo-details">
                    {file.nombre} | {file.size} | {file.date}
                  </p>
                </div>
                <i
                  className="bi bi-trash archivo-delete"
                  onClick={() => handleDeleteFile(file.id)}
                  style={{ cursor: "pointer" }}
                ></i>
              </div>
            ) : null
          )}
        </div>
      )}
    </div>
  );
};

export default FilesSection;
